module.exports = __webpack_public_path__ + "79f36b1581b2b6e646f30ef93e0394aa.svg";